import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../../../environments/environment';
import { ApiMethodService } from '../../../../tools/services/api/method-api/apiMethod.service';
import {
  RegisterParkingMarketingDashboardDto,
  RegisterParkingTableDto,
  RegisterParkingTableQuery,
} from '../../../models/parking/register-parking-list.model';

@Injectable({
  providedIn: 'root',
})
export class ApiRegisterParkingListService {
  private readonly baseUrl = environment.apiPrivateUrl;
  private readonly cookieService = inject(CookieService);
  private readonly apiMethodService = inject(ApiMethodService);

  getRegisterParkingForTable(query: RegisterParkingTableQuery): Observable<RegisterParkingTableDto> {
    const token = this.cookieService.get('token');
    const params: Record<string, string | number> = {
      siteId: query.siteId,
      userId: query.userId,
      page: query.page ?? 1,
      pageSize: query.pageSize ?? 20,
    };

    if (query.searchField) params['searchField'] = query.searchField;
    if (query.searchText) params['searchText'] = query.searchText;
    if (query.status && query.status !== 'all') params['status'] = query.status;
    if (query.startDate) params['startDate'] = query.startDate;
    if (query.endDate) params['endDate'] = query.endDate;
    if (query.minFee && query.minFee > 0) params['minFee'] = query.minFee;
    if (query.clientId && query.clientId > 0) params['clientId'] = query.clientId;

    return this.apiMethodService.request<RegisterParkingTableDto>(
      '/backoffice/getRegisterParkingForTable',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'getRegisterParkingForTable',
        token,
        headerOnly: false,
        params,
      }
    );
  }

  getRegisterParkingMarketingDashboard(
    siteId: number,
    userId: number,
    startDate?: string,
    endDate?: string,
    clientId?: number
  ): Observable<RegisterParkingMarketingDashboardDto> {
    const token = this.cookieService.get('token');
    const params: Record<string, string | number> = { siteId, userId };
    if (startDate) params['startDate'] = startDate;
    if (endDate) params['endDate'] = endDate;
    if (clientId && clientId > 0) params['clientId'] = clientId;

    return this.apiMethodService.request<RegisterParkingMarketingDashboardDto>(
      '/backoffice/getRegisterParkingMarketingDashboard',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'getRegisterParkingMarketingDashboard',
        token,
        headerOnly: false,
        params,
      }
    );
  }
}
